<template>
  <div style="padding-top:2rem;padding-bottom:2rem;">
      <div
          v-for="(item, i) in selection.areas"
          :key="i"
          link
          color="#333"
          class="item"
          @click="clickArea(item.name)"
        >
          <span v-if="item.active" class="icon">
            <v-icon class="active" size="30" color="#333">mdi-toggle-switch</v-icon>
          </span>
          <span v-else class="icon">
              <v-icon class="mr-0" size="30" color="#333">mdi-toggle-switch-off</v-icon>
          </span>
          <h5>
            <img class="iconimg" :src="imgcover(item.icon)" />
            {{ $t(item.name) }}
          </h5>
      </div>
  </div>
</template>

<script>

export default {
  name: 'SideMenuFront',
  components: {
  },
  props: ['selection'],
  data() {
    return {
      kategorien: [
        { title: 'Testfelder', value: 'field', icon: 'mdi-toggle-switch-off', iconActive: 'mdi-toggle-switch', usertype: 'admin', active: true },
        { title: 'Geräte/Services', value: 'device', icon: 'mdi-toggle-switch-off', iconActive: 'mdi-toggle-switch', usertype: 'admin', active: false },
        { title: 'Anwendungsfälle', value: 'usecase', icon: 'mdi-toggle-switch-off', iconActive: 'mdi-toggle-switch', usertype: 'admin', active: false }
      ]      
    }
  },
  methods: {
      onScroll () {
          //console.log("scrolling");
      },
      clickPartner (val) {                  
        let index = this.selection.partners.findIndex(el => el.name == val);           
        this.selection.partners[index].active = this.selection.partners[index].active == false ? true : false;
      },
      clickArea (val) {                  
        let index = this.selection.areas.findIndex(el => el.name == val);                              
        this.selection.areas[index].active = this.selection.areas[index].active == false ? true : false;
      },
      imgcover(url) {
        // console.log('imgcover - url:');
        // console.log(url);
        if (url && url !== ''){ // You can check any matching expression.
          try {
            // url = require('@/logo/fb/' + url + '.svg')
            url = require('@/images/svg/dark/' + url)
          } catch (e) {
            console.log(e);
            // url = require('@/logo/default.jpg'); // I used a default image. 
          }
        }
        else
          url = ''; // Default image. 
        return url;
      }
  },
  computed: {
      user() {
        return this.$store.state.user
      }
  },
  mounted() {
      //console.log("selection in menuFront");
      //console.log(this.selection);
  },
  watch: {
    selection(val) {
      console.log("watch selection in menuFront");
      console.log(val);
    }
  }

};
</script>

<style scoped>

.v-list {
  background-color:transparent;
}
.v-list-item {
 padding-left:18px;
}
.theme--light.v-icon,
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  text-decoration: none;
  color:#999 !important;
}
.v-list-item__icon {
  margin-right:16px !important;
}

.theme--light.v-icon.active {
  color:orange !important;
}
.theme--light.v-subheader {
    color:rgba(255, 255, 255, 1) !important;
    font-weight: bold;
    font-size:0.9rem;
    margin-top:1.8rem;
}
.overflow-y-auto {
   height:100%;
}
.iconimg {
  margin-right: 10px;
  width: 18px;
}

</style>
